import { UserPlanBadge } from "./UserPlanBadge";

// トークルームユーザーデータ
export class TalkRoomUser {
  constructor(
    public userId: string,
    public userName: string,
    public userImage: string,
    public iconPath: string = "",
    public isOwner: boolean = false,
    public userPlanBadges: UserPlanBadge[] = [], // ユーザープランバッジ一覧
  ) {}
}

// Firestore data converter
export const TalkRoomUserConverter = {
  toFirestore: (item: any) => {
    return {
      UserId: item.userId,
      UserName: item.userName,
      IconPath: item.userImage,
    };
  },
  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options);
    // return new TalkRoomUser(data.UserId, data.UserName, data.IconPath);
    // TODO userPlanBadges も設定する
    return new TalkRoomUser(data.UserId, data.UserName, data.IconPath, "", false, [
      new UserPlanBadge("https://www.gstatic.com/mobilesdk/240501_mobilesdk/firebase_28dp.png", "サンプルバッジ1"),
      new UserPlanBadge("https://www.gstatic.com/mobilesdk/240501_mobilesdk/firebase_28dp.png", "サンプルバッジ2"),
    ]);
  },
};
